// In both tables the mouse and keyboard rows are Godot 4.6's editor bindings. The
// trackpad rows are its pan-gesture bindings minus the unmodified one: a browser
// reports a two-finger scroll as a wheel event, so the wheel's zoom keeps that
// slot. Godot's editor has no touch scheme.
const CONTROLS_3D = {
    summary: 'middle-drag = orbit · shift+wheel = pan · wheel = zoom',
    touchSummary: 'drag = orbit · two fingers = pan · pinch = zoom',
    groups: [
        {
            device: 'Mouse',
            bindings: [
                {
                    input: 'Left-click',
                    action: 'Select',
                    trigger: { kind: 'drag', button: 0 },
                    resolvesTo: null,
                },
                {
                    input: 'Middle-drag',
                    action: 'Orbit',
                    trigger: { kind: 'drag', button: 1 },
                    resolvesTo: 'orbit',
                },
                {
                    input: 'Shift + middle-drag',
                    action: 'Pan',
                    trigger: { kind: 'drag', button: 1, mods: { shiftKey: true } },
                    resolvesTo: 'pan',
                },
                {
                    input: 'Ctrl + middle-drag',
                    action: 'Zoom',
                    trigger: { kind: 'drag', button: 1, mods: { ctrlKey: true } },
                    resolvesTo: 'zoom',
                },
                {
                    input: 'Wheel',
                    action: 'Zoom',
                    trigger: { kind: 'wheel' },
                    resolvesTo: 'zoom',
                },
                {
                    input: 'Shift + wheel',
                    action: 'Pan',
                    trigger: { kind: 'wheel', mods: { shiftKey: true } },
                    resolvesTo: 'pan',
                },
                {
                    input: 'Right-drag',
                    action: 'Freelook — turn the camera in place',
                    trigger: { kind: 'drag', button: 2 },
                    resolvesTo: 'freelook',
                },
                {
                    input: 'Alt + left-drag',
                    action: 'Orbit, for a mouse with no middle button',
                    trigger: { kind: 'drag', button: 0, mods: { altKey: true } },
                    resolvesTo: 'orbit',
                },
                {
                    input: 'Alt + Shift + left-drag',
                    action: 'Pan',
                    trigger: {
                        kind: 'drag',
                        button: 0,
                        mods: { altKey: true, shiftKey: true },
                    },
                    resolvesTo: 'pan',
                },
            ],
        },
        {
            device: 'Trackpad',
            bindings: [
                {
                    input: 'Two-finger scroll',
                    action: 'Zoom',
                    trigger: { kind: 'wheel' },
                    resolvesTo: 'zoom',
                },
                {
                    input: 'Shift + two-finger scroll',
                    action: 'Pan',
                    trigger: { kind: 'wheel', mods: { shiftKey: true } },
                    resolvesTo: 'pan',
                },
                {
                    input: 'Pinch',
                    action: 'Zoom',
                    trigger: { kind: 'wheel', mods: { ctrlKey: true } },
                    resolvesTo: 'zoom',
                },
            ],
        },
        {
            device: 'Touch',
            bindings: [
                { input: 'Tap', action: 'Select' },
                {
                    input: 'One-finger drag',
                    action: 'Orbit',
                    trigger: { kind: 'touch', pointers: 1 },
                    resolvesTo: 'orbit',
                },
                {
                    input: 'Two-finger drag',
                    action: 'Pan',
                    trigger: { kind: 'touch', pointers: 2 },
                    resolvesTo: 'pan',
                },
                { input: 'Pinch', action: 'Zoom' },
            ],
        },
        {
            device: 'Keyboard',
            bindings: [
                { input: 'F', action: 'Frame the selection — also lets you zoom closer in' },
                {
                    input: 'Numpad 1 / 3 / 7',
                    action: 'Front / right / top view; Ctrl for the opposite',
                },
                { input: 'Numpad 5', action: 'Perspective ⇄ orthographic' },
                {
                    input: 'W A S D Q E',
                    action: 'Fly while right-dragging (Shift sprints)',
                },
            ],
        },
    ],
};
const CONTROLS_2D = {
    summary: 'drag = pan · wheel = zoom · pinch = zoom',
    touchSummary: 'drag = pan · pinch = zoom',
    groups: [
        {
            device: 'Mouse',
            bindings: [
                { input: 'Drag', action: 'Pan' },
                { input: 'Wheel', action: 'Zoom, anchored to the cursor' },
                {
                    input: '− / + / Fit',
                    action: 'Zoom out, in, or fit the viewport rectangle',
                },
            ],
        },
        {
            device: 'Trackpad',
            bindings: [
                { input: 'Two-finger scroll', action: 'Zoom' },
                { input: 'Pinch', action: 'Zoom' },
            ],
        },
        {
            device: 'Touch',
            bindings: [
                { input: 'One-finger drag', action: 'Pan' },
                { input: 'Two-finger drag', action: 'Pan' },
                { input: 'Pinch', action: 'Zoom' },
            ],
        },
    ],
};
/** The bindings that apply in a viewport mode. */
export function controlsFor(mode) {
    return mode === '2D' ? CONTROLS_2D : CONTROLS_3D;
}
//# sourceMappingURL=bindings.js.map